import { type ComponentType } from 'react'

import { useTranslate } from './hooks'
import type { TranslateFunction } from './types'

export type WithTolgeeProps = {
  t: TranslateFunction
}

export function withTolgee<P>(Component: ComponentType<P & WithTolgeeProps>): ComponentType<P> {
  const displayName = (Component as ComponentType).displayName || Component.name || 'Component'

  const WithTolgee = (props: P) => {
    const t = useTranslate()
    return <Component {...props} t={t} />
  }

  WithTolgee.displayName = `withTolgee(${displayName})`

  return WithTolgee
}
